import { People } from '@mui/icons-material';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { GroupMessageResponse } from '../models/groupMessageResponse';
import { GroupMessageEmailStatusDataGrid } from './groupMessageEmailStatusDataGrid';
import { GroupMessageEmailStatusSearchFilter } from '../models/groupMessageEmailStatusSearchFilter';

type GroupMessageEmailStatusModalProps = {
  modalOpen: boolean;
  groupMessageEmailResponse: GroupMessageResponse;
  onSave: () => void;
  onClose: () => void;
};

export const GroupMessageEmailStatusModal = (props: GroupMessageEmailStatusModalProps) => {
  const { modalOpen, groupMessageEmailResponse, onSave, onClose } = props;
  const { t } = useTranslation(['common', 'groupMessage']);

  const onHandleSave = useCallback(() => {
    onSave();
  }, [onSave]);

  const onHandleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <GenericDialog
      open={modalOpen}
      padding={0}
      dialogTitle={t('groupMessage:sms.deliveryStatus')}
      dialogSubTitle={
        <Typography variant='body2' sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 500 }}>
          <span>{groupMessageEmailResponse.circularName}</span>
          <People fontSize='small' sx={{ fontSize: '1rem' }} />
          <span>{groupMessageEmailResponse.selectionName || groupMessageEmailResponse.speedFormText}</span>
        </Typography>
      }
      onClose={onHandleClose}
      onSave={onHandleSave}
      dialogContent={
        <Box className='section-inset' sx={{ p: 2 }}>
          <GridWrapper>
            <Grid item xs={12}>
              {groupMessageEmailResponse && groupMessageEmailResponse.circulars.length > 0 && (
                <GroupMessageEmailStatusDataGrid
                  loadingCallback={() => ConsoleHelper.log('X')}
                  searchFilter={
                    { filter: '', circular_id: groupMessageEmailResponse.circulars[0].circular_id } as unknown as GroupMessageEmailStatusSearchFilter
                  }
                />
              )}
            </Grid>
          </GridWrapper>
        </Box>
      }
      dialogActions={
        <Button variant='outlined' disableElevation onClick={onHandleClose}>
          {t('common:button.cancel')}
        </Button>
      }
    />
  );
};
